import type { Disposition } from '@/data'
import type { PaginatedResponse, ListParams } from '@/api/client'
import { buildQuery } from '@/api/client'
import api from '..'

export type PaginatedDispositions = PaginatedResponse<Disposition>

export async function getDispositions(
  params?: ListParams,
): Promise<PaginatedDispositions> {
  const res = await api.get('/dispositions', { params: buildQuery(params) })
  return { data: res.data.data, meta: res.data.meta }
}
